exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Notification__notification {\r\n    margin-bottom: 24px;\r\n}", ""]);

// exports
exports.locals = {
	"notification": "DS__Notification__notification"
};